import React from "react";
import CounsellorRegistration from "../CounsellorAllPages/CounsellorRegistration";
import CounsellorLogin from "../CounsellorAllPages/CounsellorLogin";
// import "./AuthPage.css";
import "../CounsellorRegistration/CounsellorRegistration.css";
import Footer from "../Footer/Footer";
import bgImage from "../../assets/images/brown-background.jpg";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from 'react-icons/fa';
const CounsellorRegistrations = () => {
  return (
    <div
      className="auth-pages"
    >
      <div className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}>
        <h4>Counsellor Registration</h4>
        <p>Home <span><FaChevronRight /></span> Counsellor Registration</p>

      </div>
      <div className="auth-container"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="containerall">
          <div className="auth-box">
            <div className="login-section">
              <CounsellorLogin />
            </div>

            <div className="registration-section">
              <CounsellorRegistration />
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default CounsellorRegistrations;
